import ToggleActive from "@app/utils/toggle-active";

export default class ToggleExpandCard {
    showMoreButton: HTMLElement | undefined;
    buttonText: NodeListOf<HTMLElement> | undefined;
    container: HTMLElement | undefined;
    elementDisplayStyle: string | undefined;

    constructor(showMoreButton: HTMLElement, container: HTMLElement, elementDisplayStyle: string = "flex") {
        if (showMoreButton) {
            this.showMoreButton = showMoreButton;
            this.buttonText = this.showMoreButton.querySelectorAll(".bottom-link__text") as NodeListOf<HTMLElement>;
            this.container = container;
            this.configureButton();
            this.elementDisplayStyle = elementDisplayStyle;
        }
    }

    configureButton = () => {
        if (this.container == undefined || this.showMoreButton == undefined) {
            return;
        }
        const targetElements: HTMLElement[] = [this.container, this.showMoreButton];
        for (let buttonText in this.buttonText) {
            if (this.buttonText.hasOwnProperty(buttonText)) {
                const buttonTextElement = this.buttonText[((buttonText as unknown) as number)] as HTMLElement;
                targetElements.push(buttonTextElement);
            }
        }
        const toggleHidden = new ToggleActive(targetElements, this.showMoreButton);
        toggleHidden.setPostEvent(() => { (this.container as any).slideToggle(250, "ease", 0, this.elementDisplayStyle) });
    }
}